import { useMutation } from '@tanstack/react-query';
import { sessionApi, type ChangePasswordPayload } from '@/entities/session';

/**
 * Change-password mutation (`POST {authHost}/api/v1/auth/change-password`).
 * The global error toast is suppressed — the dialog renders the backend
 * message inline (plus per-field mapping) instead.
 */
export function useChangePassword() {
  return useMutation({
    meta: { suppressErrorToast: true },
    mutationFn: (payload: ChangePasswordPayload) => sessionApi.changePassword(payload),
  });
}
